import React from "react"
import { Helmet } from "react-helmet"
import { Card, CardBody, Container } from "reactstrap"
//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import List from "./List"
function BannerAdsList() {
  const BreadcrumbDetails = {
    breadcrumbItem: {
      label: "List",
      link: "/adverts/list",
    },
    paths: [
      {
        label: "Adverts",
        link: "/adverts/list",
      },
    ],
  }
  return (
    <React.Fragment>
      <Helmet>
        <title>Adverts List | Discover Equestrian</title>
      </Helmet>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs breadcrumbDetails={BreadcrumbDetails} />
          <Card>
            <CardBody>
              <List />
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default BannerAdsList
